import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faAngleRight,
  faArrowLeft,
  faAt,
  faCheckCircle,
  faCommentAlt,
  faFilter,
  faList,
  faMapMarkerAlt,
  faTrashAlt,
  faUnlockAlt,
  faWifi,
} from '@fortawesome/free-solid-svg-icons'
import { faCircle } from '@fortawesome/free-regular-svg-icons/faCircle'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
  faAngleRight,
  faArrowLeft,
  faAt,
  faCheckCircle,
  faCommentAlt,
  faFilter,
  faList,
  faMapMarkerAlt,
  faTrashAlt,
  faUnlockAlt,
  faWifi,
  faCircle,
)

Vue.component('font-awesome-icon', FontAwesomeIcon)



// WEBPACK FOOTER //
// ./resources/assets/js/font-awesome.js